// helpers/getChicagoDate.js
const CHICAGO_TZ = "America/Chicago";

/**
 * Get current date in Chicago timezone in ISO-like format: YYYY-MM-DD
 *
 * @returns {string} Date string in format YYYY-MM-DD (Chicago time).
 */
export default function getChicagoDate() {
	const formatter = new Intl.DateTimeFormat("en-CA", {
		timeZone: CHICAGO_TZ,
		year: "numeric",
		month: "2-digit",
		day: "2-digit"
	});

	// Modern browsers: stable extraction via parts
	if (typeof formatter.formatToParts === "function") {
		const parts = formatter.formatToParts(new Date());
		const map = {};

		parts.forEach(function(p) {
			map[p.type] = p.value;
		});

		return map.year + "-" + map.month + "-" + map.day;
	}

	// Fallback: usually already "YYYY-MM-DD" for en-CA
	return formatter.format(new Date());
}
